import React from 'react';
import PairController from './components/pairController';
import './style.css';
import Header from './components/Header/index';
import DesktopFooter from './components/Deskfooter';
import { ToastContainer } from 'react-toastify';

const DesktopRoomsPlugins = () =>
{
	return (
		<div className='flexCol fullH desktopbgimage pdngSM desktopContentSelect'>
			<div className='flexRow  pdngTSM'>
				<Header />
			</div>
			<div className='flexMinHeightCol scrollY desktopPluginPdng '>
				<PairController />
			</div>
			<div className='flexAutoCol'>
				<DesktopFooter />
			</div>
			<ToastContainer
				position='top-center'
				autoClose={2000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme='light'
			/>
		</div>
	);
};

export default DesktopRoomsPlugins;
